<!-- *******************
 * 快速检索
 ************ -->

<template>
	<div class="aisearch">
		<div class="contents">
			<el-input v-model="aikeys" class="inputsearch" clearable  placeholder="海量资源 等你发现" @keyup.enter.native="handleAi"></el-input>
			<div class="searchbtn pointer" @click="handleAi"><img alt="" src="@/assets/images/searchbanner/search.png" style="width: 21px; margin-right: 10px" /> 检索</div>
		</div>
	</div>
</template>

<script>
	import Y from '@/utils/Y.js';
	import EReg from '@/utils/EReg.js';

	export default {
		data() {
			return {
				aikeys: ''
			};
		},
		components: {},
		methods: {
			handleAi() {
				if (EReg.isEmpty(this.aikeys)) {
					Y.confirm('请输入您想搜索的关键字');
					return false;
				} else {
					this.$router.push({ path: '/ai', query: { kw: this.aikeys } });
				}
			}
		},
		// 加载完执行
		created() {}
	};
</script>

<style lang="less" scoped>
	.aisearch {
		.contents {
			// width: 80%;
			border-radius: 0 7px 7px 7px;
			background-color: #ffffff;
			display: flex;
			justify-content: start; /* 水平居中 */
			align-items: center;
			.inputsearch {
				width: 90%;
				height: 50px;
				line-height: 50px;
			}
		}
		/deep/ .el-input__inner {
			border: 0;
		}
	}
</style>
